import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import type Result from 'modules/payroll_bundle/store/models/Result'

interface Props {
  result: Result
  disabled: boolean
  onClose: () => void
  onDelete: (result: Result) => void
}

const DeleteModal = ({ result, disabled, onClose, onDelete }: Props) => {
  return (
    <Modal
      title={i18n.t('payroll_bundle.payroll_results.results.delete_confirmation_title')}
      description={i18n.t('payroll_bundle.payroll_results.results.delete_confirmation_message')}
      illustration="delete"
      onClose={onClose}
      footer={
        <>
          <Button onClick={onClose} disabled={disabled} type="secondary">
            {i18n.t('common.cancel')}
          </Button>
          <Button onClick={() => onDelete(result)} type="primary" disabled={disabled}>
            {i18n.t('payroll_bundle.payroll_results.results.delete')}
          </Button>
        </>
      }
    />
  )
}

export default observer(DeleteModal)
